/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Check_VerificationInputs */



/**
* | output |
* | --- |
* | "Failed to check verification status. Please try again." |
*
* @param {Login_Error_Check_VerificationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_check_verification = /** @type {((inputs?: Login_Error_Check_VerificationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Check_VerificationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la vérification du statut. Veuillez réessayer.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Überprüfung des Verifizierungsstatus ist fehlgeschlagen. Bitte versuchen Sie es erneut.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile verificare lo stato di verifica. Riprova.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось проверить статус подтверждения. Пожалуйста, попробуйте еще раз.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo comprobar el estado de verificación. Inténtalo de nuevo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("验证状态检查失败，请重试。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("検証ステータスを確認できませんでした。もう一度お試しください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सत्यापन स्थिति की जांच करने में विफल। कृपया पुनः प्रयास करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao verificar o status da verificação. Tente novamente.")
	return /** @type {LocalizedString} */ ("Failed to check verification status. Please try again.")
});